if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        //this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart = document.querySelector('mini-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // When redirect URL is set, convert button from submit to plain button.
        // This prevents form submission entirely — UpCart can't intercept what
        // never fires. We handle cart add + insurance + redirect in one native request.
        if (this.dataset.redirectUrl) {
          this.submitButton.type = 'button';
          this.submitButton.addEventListener('click', this.onRedirectClick.bind(this));
        }
      }

      getButtonText() {
        return this.submitButton ? this.submitButton.textContent.trim().replace(/\s+/g, ' ') : '';
      }

      getButtonLocation() {
        if (this.closest('.sticky-atc, .sticky-atc--aov556')) return 'sticky_add_to_cart';
        if (this.closest('quick-add-modal')) return 'quick_add';
        if (this.closest('product-info')) return 'product_form';
        return 'product_form';
      }

      cleanAnalyticsPayload(payload) {
        const clean = {};
        Object.keys(payload || {}).forEach((key) => {
          if (payload[key] !== undefined) clean[key] = payload[key];
        });
        return clean;
      }

      trackAnalyticsEvent(eventName, params) {
        const payload = this.cleanAnalyticsPayload(Object.assign({
          event_category: '556_aov_offer',
          page_location: window.location.href,
          page_path: window.location.pathname,
          page_title: document.title,
          product_id: this.dataset.productId || '',
          product_title: this.dataset.productTitle || '',
          product_handle: this.dataset.productHandle || ''
        }, params || {}));

        try {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(Object.assign({ event: eventName }, payload));
        } catch (error) {}

        try {
          if (typeof window.gtag === 'function') window.gtag('event', eventName, payload);
        } catch (error) {}

        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish(eventName, payload);
          }
        } catch (error) {}
      }

      getAovUpsellConfig(formData) {
        const productInfo = this.closest('product-info') || document;
        const selectedVariantId = parseInt(formData.get('id'), 10);
        const tierGiftPromo = productInfo.querySelector('[data-tier-gift-promo]');

        if (tierGiftPromo) {
          const offerId = tierGiftPromo.dataset.offerId || '40-380-range-bonus';
          const parentProductId = tierGiftPromo.dataset.productId || productInfo.dataset.productId || '';
          const tiers = [
            {
              key: '500',
              variantId: parseInt(this.getDatasetValue(tierGiftPromo, 'tier500VariantId', 'tier-500VariantId'), 10),
              giftVariantId: parseInt(this.getDatasetValue(tierGiftPromo, 'tier500GiftVariantId', 'tier-500GiftVariantId'), 10),
            },
            {
              key: '300',
              variantId: parseInt(this.getDatasetValue(tierGiftPromo, 'tier300VariantId', 'tier-300VariantId'), 10),
              giftVariantId: parseInt(this.getDatasetValue(tierGiftPromo, 'tier300GiftVariantId', 'tier-300GiftVariantId'), 10),
            },
          ];
          const selectedTierControl = this.getSelectedTierGiftControl(productInfo);
          const selectedTierKey = selectedTierControl?.dataset?.tierGiftOption || '';
          const selectedControlVariantId = parseInt(selectedTierControl?.dataset?.variantId, 10);
          const resolvedVariantId = selectedControlVariantId || selectedVariantId;
          const selectedTier = tiers.find((tier) => {
            if (!tier.variantId || !tier.giftVariantId) return false;
            return (selectedTierKey && selectedTierKey === tier.key) || resolvedVariantId === tier.variantId;
          });

          if (selectedTier) {
            return {
              offerId,
              tierKey: selectedTier.key,
              giftVariantId: selectedTier.giftVariantId,
              giftQuantity: 'match',
              selectedVariantId: selectedTier.variantId,
              triggerVariantId: selectedTier.variantId,
              giftProperties: {
                _free_gift: 'true',
                _aov_offer: offerId,
                _aov_gift_tier: selectedTier.key,
                _aov_parent_variant_id: String(selectedTier.variantId),
                _aov_parent_product_id: String(parentProductId),
              },
            };
          }
        }

        const aov556 = productInfo.querySelector('[data-556-aov-upsell]') || document.querySelector('[data-556-aov-upsell]');

        if (aov556) {
          const selectedAov556VariantId = this.getSelectedAov556VariantId(formData, productInfo);
          const tiers = [
            {
              key: '1000',
              variantId: parseInt(this.getDatasetValue(aov556, 'tier1000VariantId', 'tier-1000VariantId'), 10),
              giftVariantId: parseInt(this.getDatasetValue(aov556, 'tier1000GiftVariantId', 'tier-1000GiftVariantId'), 10),
            },
            {
              key: '500',
              variantId: parseInt(this.getDatasetValue(aov556, 'tier500VariantId', 'tier-500VariantId'), 10),
              giftVariantId: parseInt(this.getDatasetValue(aov556, 'tier500GiftVariantId', 'tier-500GiftVariantId'), 10),
            },
            {
              key: '300',
              variantId: parseInt(this.getDatasetValue(aov556, 'tier300VariantId', 'tier-300VariantId'), 10),
              giftVariantId: parseInt(this.getDatasetValue(aov556, 'tier300GiftVariantId', 'tier-300GiftVariantId'), 10),
            },
          ];
          const selectedTier = tiers.find((tier) => tier.variantId && tier.giftVariantId && selectedAov556VariantId === tier.variantId);

          if (selectedTier) {
            return {
              offerId: '556-tiered-gift',
              tierKey: selectedTier.key,
              giftVariantId: selectedTier.giftVariantId,
              selectedVariantId: selectedAov556VariantId,
              triggerVariantId: selectedTier.variantId,
              giftProperties: {
                _free_gift: 'true',
                _aov_offer: '556-tiered-gift',
                _aov_gift_tier: selectedTier.key,
                _aov_parent_variant_id: String(selectedTier.variantId),
              },
            };
          }
        }

        const upsell = productInfo.querySelector('[data-aov-upsell]');
        if (!upsell) return null;

        const giftVariantId = parseInt(upsell.dataset.giftVariantId, 10);
        const triggerVariantId = parseInt(upsell.dataset.triggerVariantId, 10);

        if (!giftVariantId || !triggerVariantId || selectedVariantId !== triggerVariantId) return null;

        return {
          offerId: '22lr-2100',
          giftVariantId,
          selectedVariantId,
          triggerVariantId,
          giftProperties: {
            _free_gift: 'true',
            _aov_gift: '22lr-2100',
          },
        };
      }

      getLineItemProperties(formData) {
        const properties = {};

        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && value !== '') {
            properties[match[1]] = value;
          }
        });

        return properties;
      }

      getDatasetValue(element, ...keys) {
        const dataset = element?.dataset || {};
        for (const key of keys) {
          if (dataset[key] !== undefined && dataset[key] !== '') return dataset[key];
        }
        return '';
      }

      getSelectedTierGiftControl(productInfo) {
        const primarySelectors = [
          'variant-selects[data-primary] input[data-tier-gift-option]:checked',
          'variant-selects[data-primary] select option[data-tier-gift-option]:checked',
        ];
        const stickySelectors = [
          'variant-selects[data-sticky] input[data-tier-gift-option]:checked',
          'variant-selects[data-sticky] select option[data-tier-gift-option]:checked',
        ];
        const isStickyForm = Boolean(this.closest('.sticky-atc'));
        const selectors = isStickyForm
          ? stickySelectors.concat(primarySelectors)
          : primarySelectors.concat(stickySelectors);
        const scopes = [this, isStickyForm ? this.closest('.sticky-atc') : productInfo, productInfo, document].filter(Boolean);

        for (const scope of scopes) {
          for (const selector of selectors) {
            const control = scope.querySelector?.(selector);
            if (control) return control;
          }
        }

        return null;
      }

      getSelectedAov556Control(productInfo) {
        const primarySelectors = [
          'variant-selects[data-primary] input[data-aov556-tier-option]:checked',
          'variant-selects[data-primary] select option[data-aov556-tier-option]:checked',
        ];
        const stickySelectors = [
          'variant-selects[data-sticky] input[data-aov556-tier-option]:checked',
          'variant-selects[data-sticky] select option[data-aov556-tier-option]:checked',
        ];
        const isStickyForm = Boolean(this.closest('.sticky-atc'));
        const selectors = isStickyForm
          ? stickySelectors.concat(primarySelectors)
          : primarySelectors.concat(stickySelectors);
        const scopes = [this, isStickyForm ? this.closest('.sticky-atc') : productInfo, productInfo, document].filter(Boolean);

        for (const scope of scopes) {
          for (const selector of selectors) {
            const control = scope.querySelector?.(selector);
            if (control) return control;
          }
        }

        return null;
      }

      getSelectedAov556VariantId(formData, productInfo = this.closest('product-info') || document) {
        const selectedControl = this.getSelectedAov556Control(productInfo);
        const selectedControlVariantId = parseInt(selectedControl?.dataset?.aov556VariantId, 10);

        return selectedControlVariantId || parseInt(formData.get('id'), 10);
      }

      getAov556ShirtPackRoot(productInfo = this.closest('product-info') || document) {
        const scopedRoot = productInfo?.querySelector?.('[data-aov556-shirt-pack][data-enabled="true"]');
        if (scopedRoot) return scopedRoot;

        return document.querySelector('[data-aov556-shirt-pack][data-enabled="true"]');
      }

      parseAov556ShirtPackVariants(root) {
        const source = root?.querySelector?.('[data-aov556-shirt-pack-variants]');
        if (!source || !source.textContent) return {};

        try {
          return JSON.parse(source.textContent);
        } catch (error) {
          return {};
        }
      }

      getAov556ShirtPackModal(root) {
        const modalId = root?.dataset?.modalId;
        return modalId ? document.getElementById(modalId) : null;
      }

      getAov556ShirtPackSelection(formData, aovConfig = this.getAovUpsellConfig(formData)) {
        if (this.dataset.aov556Offer !== 'true') return null;
        if (!aovConfig || aovConfig.offerId !== '556-tiered-gift') return null;

        const selectedVariantId = aovConfig.selectedVariantId ||
          this.getSelectedAov556VariantId(formData);
        const tierData = this.getAov556TierData(aovConfig.tierKey, selectedVariantId);
        const tierKey = aovConfig.tierKey || tierData?.tierKey;

        if (!['300', '500', '1000'].includes(tierKey)) return null;

        const productInfo = this.closest('product-info') || document;
        const root = this.getAov556ShirtPackRoot(productInfo);
        if (!root) return null;

        const variantsBySize = this.parseAov556ShirtPackVariants(root);
        const checkedSizeInput = root.querySelector('[data-aov556-shirt-pack-size]:checked');
        const selectedSize = checkedSizeInput?.value || root.dataset.selectedSize || '';
        const shirtItems = Array.isArray(variantsBySize[selectedSize])
          ? variantsBySize[selectedSize].filter((item) => parseInt(item.id, 10))
          : [];

        if (selectedSize) root.dataset.selectedSize = selectedSize;

        return {
          root,
          modal: this.getAov556ShirtPackModal(root),
          variantsBySize,
          selectedSize,
          shirtItems,
          tierKey,
          selectedVariantId,
          valueLabel: root.dataset.valueLabel || '$100',
          valid: Boolean(selectedSize && shirtItems.length === 3),
        };
      }

      ensureAov556ShirtPackSize(formData, aovConfig, mode) {
        const selection = this.getAov556ShirtPackSelection(formData, aovConfig);
        if (!selection) return true;

        if (selection.valid) {
          if (aovConfig) aovConfig.shirtPackSelection = selection;
          return true;
        }

        this.openAov556ShirtPackModal(selection, mode);
        return false;
      }

      openAov556ShirtPackModal(selection, mode) {
        const modal = selection?.modal;
        const root = selection?.root;

        if (!modal || !root) {
          this.handleErrorMessage('Please choose a shirt size before adding this bundle.');
          return;
        }

        this.initializeAov556ShirtPackModal(root, modal);

        const selectedSize = root.dataset.selectedSize || '';
        modal.querySelectorAll('[data-aov556-shirt-pack-size]').forEach((input) => {
          input.checked = selectedSize ? input.value === selectedSize : false;
        });

        const confirmButton = modal.querySelector('[data-aov556-shirt-pack-confirm]');
        if (confirmButton) confirmButton.disabled = !selectedSize;

        modal.__aov556PendingAdd = { form: this, mode };

        if (typeof modal.show === 'function') {
          modal.show(this.submitButton);
        } else {
          modal.setAttribute('open', '');
        }

        const focusTarget = modal.querySelector('[data-aov556-shirt-pack-size]:checked') ||
          modal.querySelector('[data-aov556-shirt-pack-size]') ||
          confirmButton;
        if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
      }

      hideAov556ShirtPackModal(modal) {
        if (!modal) return;

        if (typeof modal.hide === 'function') {
          modal.hide();
        } else {
          modal.removeAttribute('open');
        }
      }

      initializeAov556ShirtPackModal(root, modal) {
        if (modal.dataset.aov556ShirtPackInitialized === 'true') return;

        modal.dataset.aov556ShirtPackInitialized = 'true';

        const confirmButton = modal.querySelector('[data-aov556-shirt-pack-confirm]');
        const cancelButton = modal.querySelector('[data-aov556-shirt-pack-cancel]');
        const sizeInputs = Array.from(modal.querySelectorAll('[data-aov556-shirt-pack-size]'));
        const syncConfirmState = () => {
          if (!confirmButton) return;
          confirmButton.disabled = !sizeInputs.some((input) => input.checked);
        };

        sizeInputs.forEach((input) => {
          input.addEventListener('change', syncConfirmState);
        });

        if (confirmButton) {
          confirmButton.addEventListener('click', (event) => {
            event.preventDefault();

            const selectedInput = sizeInputs.find((input) => input.checked);
            if (!selectedInput) {
              syncConfirmState();
              return;
            }

            root.dataset.selectedSize = selectedInput.value;
            root.querySelectorAll('[data-aov556-shirt-pack-size]').forEach((input) => {
              input.checked = input.value === selectedInput.value;
            });

            const pendingAdd = modal.__aov556PendingAdd || {};
            modal.__aov556PendingAdd = null;
            this.hideAov556ShirtPackModal(modal);

            window.setTimeout(() => {
              const pendingForm = pendingAdd.form;
              if (!pendingForm || !document.body.contains(pendingForm)) return;

              if (pendingAdd.mode === 'redirect') {
                pendingForm.onRedirectClick(new Event('click'));
              } else {
                pendingForm.onSubmitHandler(new Event('submit', { bubbles: true, cancelable: true }));
              }
            }, 0);
          });
        }

        if (cancelButton) {
          cancelButton.addEventListener('click', (event) => {
            event.preventDefault();
            modal.__aov556PendingAdd = null;
            this.hideAov556ShirtPackModal(modal);
          });
        }
      }

      getAov556TierData(tierKey, selectedVariantId) {
        const productInfo = this.closest('product-info') || document;
        const aov556 = productInfo.querySelector('[data-556-aov-upsell]') || document.querySelector('[data-556-aov-upsell]');

        if (!aov556 && !tierKey) return null;

        const offerProfile = aov556 ? (this.getDatasetValue(aov556, 'aov556OfferProfile') || '556') : '556';
        const tierMap = offerProfile === '22lr'
          ? {
              300: { roundCount: 2100, packageLabel: '4-Box Package' },
              500: { roundCount: 3150, packageLabel: '6-Box Package' },
              1000: { roundCount: 4200, packageLabel: '8-Box Package' },
              base: { roundCount: null, packageLabel: 'Selected Package' },
            }
          : {
              300: { roundCount: 300, packageLabel: '300-Round Bundle' },
              500: { roundCount: 500, packageLabel: '500-Round Bundle' },
              1000: { roundCount: 1000, packageLabel: '1,000-Round Bundle' },
              base: { roundCount: null, packageLabel: 'Selected Package' },
            };

        let resolvedTierKey = tierKey || 'base';

        if (aov556 && selectedVariantId) {
          ['300', '500', '1000'].some((key) => {
            if (parseInt(this.getDatasetValue(aov556, `tier${key}VariantId`, `tier-${key}VariantId`), 10) === selectedVariantId) {
              resolvedTierKey = key;
              return true;
            }
            return false;
          });
        }

        const fallback = tierMap[resolvedTierKey] || tierMap.base;
        const prefix = resolvedTierKey !== 'base' ? `tier${resolvedTierKey}` : null;
        const legacyPrefix = resolvedTierKey !== 'base' ? `tier-${resolvedTierKey}` : null;
        const readTierValue = (suffix) => {
          if (!aov556 || !prefix || !legacyPrefix) return '';
          return this.getDatasetValue(aov556, `${prefix}${suffix}`, `${legacyPrefix}${suffix}`);
        };

        return {
          tierKey: resolvedTierKey,
          roundCount: fallback.roundCount,
          packageLabel: readTierValue('Label') || fallback.packageLabel,
          bonusShort: readTierValue('BonusShort') || '',
          giftTitle: readTierValue('GiftTitle') || '',
          giftValue: readTierValue('GiftValue') || '',
        };
      }

      getSelectedVariantData(selectedVariantId) {
        const productInfo = this.closest('product-info') || document;
        const sticky = this.closest('.sticky-atc');
        const variantSources = [];

        if (sticky) variantSources.push(sticky.querySelector('variant-selects[data-sticky] script[type="application/json"]'));
        variantSources.push(productInfo.querySelector('variant-selects[data-primary] [data-selected-variant]'));
        variantSources.push(document.querySelector('variant-selects[data-primary] [data-selected-variant]'));
        variantSources.push(document.querySelector('.sticky-atc--aov556 variant-selects[data-sticky] script[type="application/json"]'));

        for (const source of variantSources) {
          if (!source || !source.textContent) continue;

          try {
            const parsed = JSON.parse(source.textContent);
            if (Array.isArray(parsed)) {
              const match = parsed.find((variant) => parseInt(variant.id, 10) === selectedVariantId);
              if (match) return match;
            } else if (parseInt(parsed.id, 10) === selectedVariantId) {
              return parsed;
            }
          } catch (error) {
            // Variant metadata is best-effort for analytics only.
          }
        }

        return null;
      }

      getProductAnalyticsData() {
        const productInfo = this.closest('product-info');
        const titleNode = productInfo?.querySelector('.product__title, h1, h2');

        return {
          productId: this.dataset.productId || productInfo?.dataset.productId || '',
          productTitle: this.dataset.productTitle || titleNode?.textContent?.trim() || document.title,
          productHandle: this.dataset.productHandle || '',
          productVendor: this.dataset.productVendor || '',
          productType: this.dataset.productType || '',
          currency: this.dataset.productCurrency || theme.shopSettings?.isoCode || window.Shopify?.currency?.active || 'USD',
        };
      }

      trackGoogleEvent(eventName, payload, options = {}) {
        const cleanPayload = this.cleanAnalyticsPayload(payload || {});

        window.dataLayer = window.dataLayer || [];
        if (options.resetEcommerce) window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(Object.assign({ event: eventName }, cleanPayload));

        if (typeof window.gtag === 'function') {
          const gtagPayload = this.cleanAnalyticsPayload(Object.assign({}, cleanPayload, cleanPayload.ecommerce || {}));
          delete gtagPayload.ecommerce;
          window.gtag('event', eventName, gtagPayload);
        }
      }

      trackAddToCartAnalytics(formData, response, aovConfig = null) {
        if (this.dataset.aov556Offer !== 'true') return;

        const selectedVariantId = aovConfig?.selectedVariantId ||
          (this.dataset.aov556Offer === 'true' ? this.getSelectedAov556VariantId(formData) : parseInt(formData.get('id'), 10));
        if (!selectedVariantId) return;

        const quantity = parseInt(formData.get('quantity'), 10) || 1;
        const variantData = this.getSelectedVariantData(selectedVariantId) || {};
        const productData = this.getProductAnalyticsData();
        const tierData = this.getAov556TierData(aovConfig?.tierKey, selectedVariantId) || {};
        const shirtPackSelection = aovConfig?.shirtPackSelection;
        const variantTitle = variantData.title || tierData.packageLabel || String(selectedVariantId);
        const priceCents = Number.isFinite(Number(variantData.price)) ? Number(variantData.price) : null;
        const price = priceCents !== null ? priceCents / 100 : null;
        const value = price !== null ? Math.round(price * quantity * 100) / 100 : undefined;
        const eventId = `aov556_${selectedVariantId}_${Date.now()}`;
        const item = this.cleanAnalyticsPayload({
          item_id: String(variantData.sku || selectedVariantId),
          item_name: productData.productTitle,
          item_variant: variantTitle,
          item_brand: productData.productVendor || 'Pro Armory',
          item_category: productData.productType || 'Ammo',
          item_list_name: '556 AOV PDP',
          price: price,
          quantity: quantity,
          shopify_product_id: productData.productId ? String(productData.productId) : undefined,
          shopify_variant_id: String(selectedVariantId),
          selected_package_tier: tierData.tierKey || 'base',
          selected_round_count: tierData.roundCount || undefined,
        });
        const ecommerce = this.cleanAnalyticsPayload({
          currency: productData.currency,
          items: [item],
        });

        if (value !== undefined) ecommerce.value = value;

        this.trackGoogleEvent('add_to_cart', {
          event_id: eventId,
          event_source: '556_aov_product_form',
          ecommerce,
          currency: productData.currency,
          value: value,
          product_id: productData.productId ? String(productData.productId) : undefined,
          product_handle: productData.productHandle || undefined,
          product_title: productData.productTitle,
          variant_id: String(selectedVariantId),
          variant_title: variantTitle,
          variant_sku: variantData.sku || undefined,
          quantity,
          selected_package_tier: tierData.tierKey || 'base',
          selected_package_label: tierData.packageLabel || variantTitle,
          selected_round_count: tierData.roundCount || undefined,
          aov_offer_id: aovConfig?.offerId || undefined,
          bonus_included: Boolean(aovConfig),
          bonus_description: tierData.bonusShort || undefined,
          bonus_value: tierData.giftValue || undefined,
          gift_variant_id: aovConfig?.giftVariantId ? String(aovConfig.giftVariantId) : undefined,
          gift_title: tierData.giftTitle || undefined,
          shirt_pack_included: Boolean(shirtPackSelection?.valid) || undefined,
          shirt_pack_size: shirtPackSelection?.selectedSize || undefined,
          shirt_pack_variant_ids: shirtPackSelection?.shirtItems?.map((item) => String(item.id)).join(',') || undefined,
        }, { resetEcommerce: true });
      }

      getShippingInsuranceCartItem() {
        if (this.dataset.skipShippingInsurance === 'true') return null;

        const insuranceEnabled = theme.shopSettings?.shippingInsuranceEnabled;
        const insuranceVariantId = parseInt(theme.shopSettings?.shippingInsuranceVariantId, 10);

        if (!insuranceEnabled || !insuranceVariantId) return null;

        return {
          id: insuranceVariantId,
          quantity: 1,
        };
      }

      getSelectedVariantPriceCents(formData) {
        const selectedVariantId = String(formData.get('id') || '');
        const controls = Array.from(this.form.querySelectorAll('[name="id"]'));
        let priceSource = null;

        controls.some((control) => {
          if (control.tagName === 'SELECT') {
            const selectedOption = control.selectedOptions?.[0];
            if (selectedOption && String(selectedOption.value) === selectedVariantId) {
              priceSource = selectedOption;
              return true;
            }
            return false;
          }

          if (String(control.value) === selectedVariantId) {
            priceSource = control;
            return true;
          }
          return false;
        });

        const priceCents = Number.parseInt(priceSource?.dataset.priceCents || '', 10);
        return Number.isFinite(priceCents) && priceCents > 0 ? priceCents : 0;
      }

      buildPrimaryCartItem(formData) {
        const selectedVariantId = Number.parseInt(formData.get('id'), 10);
        if (!selectedVariantId) return null;

        const primaryItem = {
          id: selectedVariantId,
          quantity: Number.parseInt(formData.get('quantity'), 10) || 1,
        };
        const sellingPlanId = Number.parseInt(formData.get('selling_plan'), 10);
        const properties = this.getLineItemProperties(formData);

        if (sellingPlanId) primaryItem.selling_plan = sellingPlanId;
        if (Object.keys(properties).length) primaryItem.properties = properties;
        return primaryItem;
      }

      async getBundledShippingInsuranceItem(formData) {
        if (this.dataset.bundleShippingInsurance !== 'true') return null;
        if (this.dataset.skipShippingInsurance === 'true') return null;
        if (!theme.shopSettings?.shippingInsuranceEnabled) return null;

        const core = window.SubscriptionInsuranceCore;
        if (!core?.determineInsuranceAction || !core?.executeInsuranceAction) {
          console.warn('[ProductForm] Shipping Insurance Core is unavailable; using global auto-sync.');
          return null;
        }

        const quantity = Number.parseInt(formData.get('quantity'), 10) || 1;
        const merchandiseSubtotalDelta = this.getSelectedVariantPriceCents(formData) * quantity;
        if (!merchandiseSubtotalDelta) {
          console.warn('[ProductForm] Selected variant price is unavailable; using global insurance auto-sync.');
          return null;
        }

        try {
          const insuranceAction = await core.determineInsuranceAction(false, null, {
            merchandiseSubtotalDelta,
          });
          return await core.executeInsuranceAction(insuranceAction);
        } catch (error) {
          console.warn('[ProductForm] Core insurance resolution failed; using global auto-sync.', error);
          return null;
        }
      }

      buildBundledShippingInsurancePayload(formData, sectionsToRender, insuranceItem) {
        if (!insuranceItem) return null;

        const primaryItem = this.buildPrimaryCartItem(formData);
        if (!primaryItem) return null;

        const payload = {
          items: [primaryItem, insuranceItem],
        };

        if (sectionsToRender.length) {
          payload.sections = sectionsToRender;
          payload.sections_url = window.location.pathname;
        }

        return payload;
      }

      payloadIncludesShippingInsurance(payload) {
        const configuredVariantIds = theme.shopSettings?.shippingInsuranceVariantIds || [
          theme.shopSettings?.shippingInsuranceVariantId,
        ];
        const insuranceVariantIds = new Set(
          configuredVariantIds
            .map((variantId) => Number.parseInt(variantId, 10))
            .filter(Number.isFinite)
        );
        if (!insuranceVariantIds.size || !payload?.items?.length) return false;

        return payload.items.some((item) => insuranceVariantIds.has(Number.parseInt(item.id, 10)));
      }

      async removeShippingInsuranceForDirectCheckout() {
        if (this.dataset.skipShippingInsurance !== 'true') return;

        const insuranceVariantId = parseInt(theme.shopSettings?.shippingInsuranceVariantId, 10);
        if (!insuranceVariantId) return;

        const cartFetch = window.__nativeFetch || fetch;
        const response = await cartFetch(theme.routes.cart_update_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            updates: {
              [insuranceVariantId]: 0,
            },
            attributes: {
              'shipping-insurance': '',
            },
          }),
        });

        if (!response.ok) {
          throw new Error('Unable to remove shipping insurance before checkout.');
        }
      }

      buildAovCartAddPayload(formData, sectionsToRender, aovConfig = this.getAovUpsellConfig(formData)) {
        const isAovOfferForm = this.dataset.aov556Offer === 'true';
        if (!aovConfig && !isAovOfferForm) return null;

        const quantity = parseInt(formData.get('quantity'), 10) || 1;
        const selectedVariantId = aovConfig?.selectedVariantId ||
          (this.dataset.aov556Offer === 'true' ? this.getSelectedAov556VariantId(formData) : parseInt(formData.get('id'), 10));
        if (!selectedVariantId) return null;

        const primaryItem = {
          id: selectedVariantId,
          quantity,
        };
        const sellingPlanId = parseInt(formData.get('selling_plan'), 10);
        const properties = this.getLineItemProperties(formData);

        if (sellingPlanId) {
          primaryItem.selling_plan = sellingPlanId;
        }

        if (Object.keys(properties).length) {
          primaryItem.properties = properties;
        }

        const items = [primaryItem];

        if (aovConfig?.giftVariantId) {
          const giftQuantity = aovConfig.giftQuantity === 'match'
            ? quantity
            : parseInt(aovConfig.giftQuantity, 10) || 1;

          items.push({
            id: aovConfig.giftVariantId,
            quantity: giftQuantity,
            properties: aovConfig.giftProperties,
          });
        }

        const shirtPackSelection = aovConfig?.shirtPackSelection ||
          this.getAov556ShirtPackSelection(formData, aovConfig);

        if (shirtPackSelection?.valid) {
          shirtPackSelection.shirtItems.forEach((shirtItem) => {
            items.push({
              id: parseInt(shirtItem.id, 10),
              quantity: 1,
              properties: {
                _free_gift: 'true',
                _aov_offer: '556-shirt-pack',
                _aov_parent_offer: '556-tiered-gift',
                _aov_gift_type: 'patriot-shirt-pack',
                _aov_parent_variant_id: String(shirtPackSelection.selectedVariantId),
                _aov_gift_tier: shirtPackSelection.tierKey,
                _shirt_pack_size: shirtPackSelection.selectedSize,
                _shirt_pack_design: shirtItem.design || shirtItem.title || 'Patriot Tee',
              },
            });
          });
        }

        const shippingInsuranceItem = this.getShippingInsuranceCartItem();
        if (shippingInsuranceItem) items.push(shippingInsuranceItem);

        const payload = {
          items,
        };

        if (sectionsToRender.length) {
          payload.sections = sectionsToRender;
          payload.sections_url = window.location.pathname;
        }

        return payload;
      }

      getRoot() {
        return window.Shopify?.routes?.root || '/';
      }

      async onRedirectClick(evt) {

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.submitButton.disabled) return;

        const formData = new FormData(this.form);
        const aovConfig = this.getAovUpsellConfig(formData);
        if (!this.ensureAov556ShirtPackSize(formData, aovConfig, 'redirect')) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const redirectUrl = this.dataset.redirectUrl;
        const cartFetch = window.__nativeFetch || fetch;
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const aovPayload = this.buildAovCartAddPayload(formData, [], aovConfig);
        const bundledInsuranceItem = aovPayload ? null : await this.getBundledShippingInsuranceItem(formData);
        const bundledInsurancePayload = this.buildBundledShippingInsurancePayload(
          formData,
          [],
          bundledInsuranceItem
        );
        const cartAddPayload = aovPayload || bundledInsurancePayload;
        const selectedVariantId = aovConfig?.selectedVariantId ||
          (this.dataset.aov556Offer === 'true' ? this.getSelectedAov556VariantId(formData) : parseInt(formData.get('id'), 10));
        const quantity = parseInt(formData.get('quantity'), 10) || 1;
        const tierData = this.dataset.aov556Offer === 'true'
          ? this.getAov556TierData(aovConfig?.tierKey, selectedVariantId)
          : null;
        const selectedTier = aovConfig && aovConfig.giftProperties ? aovConfig.giftProperties._aov_gift_tier : (tierData?.tierKey || 'base');

        if (this.dataset.aov556Offer === 'true') {
          if (!aovConfig && selectedTier && selectedTier !== 'base') {
            this.trackAnalyticsEvent('aov556_bonus_config_missing', {
              offer_id: '556-tiered-gift',
              tier: selectedTier,
              variant_id: Number.isFinite(selectedVariantId) ? selectedVariantId : null,
              button_location: this.getButtonLocation(),
              redirect_url: redirectUrl
            });
          }

          this.trackAnalyticsEvent('aov556_pdp_button_clicked', {
            offer_id: '556-tiered-gift',
            button_action: 'add_bundle',
            button_text: this.getButtonText(),
            button_location: this.getButtonLocation(),
            tier: selectedTier,
            variant_id: Number.isFinite(selectedVariantId) ? selectedVariantId : null,
            gift_variant_id: aovConfig ? aovConfig.giftVariantId : null,
            quantity: quantity,
            redirect_url: redirectUrl
          });
        }

        if (cartAddPayload) {
          config.headers['Content-Type'] = 'application/json';
          config.headers['Accept'] = 'application/json';
          config.body = JSON.stringify(cartAddPayload);
        } else {
          config.body = formData;
        }

        cartFetch(`${theme.routes.cart_add_url}`, config)
          .then((r) => r.json())
          .then(async (data) => {
            if (data.status) {
              this.handleErrorMessage(data.description);
              this.submitButton.classList.remove('loading');
              this.submitButton.removeAttribute('aria-disabled');
              return;
            }

            if (this.dataset.aov556Offer === 'true') {
              this.trackAnalyticsEvent('aov556_bundle_add_to_cart', {
                offer_id: '556-tiered-gift',
                tier: selectedTier,
                variant_id: Number.isFinite(selectedVariantId) ? selectedVariantId : null,
                gift_variant_id: aovConfig ? aovConfig.giftVariantId : null,
                quantity: quantity,
                items_count: aovPayload && aovPayload.items ? aovPayload.items.length : 1,
                shirt_pack_included: Boolean(aovConfig?.shirtPackSelection?.valid),
                shirt_pack_size: aovConfig?.shirtPackSelection?.selectedSize || null,
                shirt_pack_variant_ids: aovConfig?.shirtPackSelection?.shirtItems?.map((item) => String(item.id)).join(',') || null,
                button_location: this.getButtonLocation(),
                redirect_url: redirectUrl
              });
            }
            this.trackAddToCartAnalytics(formData, data, aovConfig);

            try {
              await this.removeShippingInsuranceForDirectCheckout();
            } catch (error) {
              console.error('Shipping insurance opt-out:', error);
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: selectedVariantId || formData.get('id'),
              shippingInsuranceIncluded: this.payloadIncludesShippingInsurance(cartAddPayload),
              skipShippingInsuranceAutoAdd: this.dataset.skipShippingInsurance === 'true',
              cartData: data,
            });

            window.location.href = redirectUrl;
          })
          .catch(() => { window.location.href = redirectUrl; });
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) return;

        const formData = new FormData(this.form);
        const aovConfig = this.getAovUpsellConfig(formData);
        if (!this.ensureAov556ShirtPackSize(formData, aovConfig, 'submit')) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        //this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        let sectionsToRender = [];

        if (this.cart) {
          sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id);
          this.cart.setActiveElement(document.activeElement);
        }

        const aovPayload = this.buildAovCartAddPayload(formData, sectionsToRender, aovConfig);
        const bundledInsuranceItem = aovPayload ? null : await this.getBundledShippingInsuranceItem(formData);
        const bundledInsurancePayload = this.buildBundledShippingInsurancePayload(
          formData,
          sectionsToRender,
          bundledInsuranceItem
        );
        const cartAddPayload = aovPayload || bundledInsurancePayload;
        const selectedVariantId = aovConfig?.selectedVariantId ||
          (this.dataset.aov556Offer === 'true' ? this.getSelectedAov556VariantId(formData) : parseInt(formData.get('id'), 10));

        if (cartAddPayload) {
          config.headers['Content-Type'] = 'application/json';
          config.headers['Accept'] = 'application/json';
          config.body = JSON.stringify(cartAddPayload);
        } else {
          if (sectionsToRender.length) {
            formData.append('sections', sectionsToRender);
            formData.append('sections_url', window.location.pathname);
          }

          config.body = formData;
        }

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: selectedVariantId || formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.trackAddToCartAnalytics(formData, response, aovConfig);

            if (!this.cart) {
              const cartLink = document.getElementById('cart-icon-bubble');
              if (cartLink) { cartLink.click(); } else { window.location = theme.routes.cart_url; }
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: selectedVariantId || formData.get('id'),
                shippingInsuranceIncluded: this.payloadIncludesShippingInsurance(cartAddPayload),
                skipShippingInsuranceAutoAdd: this.dataset.skipShippingInsurance === 'true',
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            //this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      blockSubmitIfRequiredFieldsEmpty(event) {
        if (!(this.form instanceof HTMLFormElement)) {
          throw new Error("Expected a form element.");
        }

        const formId = this.form.getAttribute('id');
        const requiredFields = document.querySelectorAll('[required]');
        let allFilled = true;
        for (const field of requiredFields) {
          const belongsToForm = (field.getAttribute('form') === formId || field.closest('form')?.id === formId);
          if (!belongsToForm) continue;
          
          let isValid = true;
          switch (field.type) {
            case 'checkbox':
            case 'radio':
              const group = document.querySelectorAll(`input[name="${field.name}"][type="${field.type}"]`);
              const isChecked = Array.from(group).some(input => input.checked);
              isValid = isChecked;
              break;
            case 'select-one':
              isValid = field.value !== '';
              break;
            case 'textarea':
            case 'text':
            case 'email':
            case 'number':
            case 'url':
            default:
              isValid = field.value.trim() !== '';
              break;
          }
          if (!isValid) {
            allFilled = false;
            field.classList.add('invalid');
          } else {
            field.classList.remove('invalid');
          }
        }
    
        if (!allFilled) {
          event.preventDefault();
          this.handleErrorMessage(theme.accessibilityStrings.fillInAllLineItemPropertyRequiredFields);
          return false;
        }
        return true;
      }
      
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = theme.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
